(() => {
  'use strict';

  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => [...root.querySelectorAll(selector)];
  const body = document.body;
  const lang = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  const dictionaries = {
    nl: {
      empty: 'Je winkelwagen is leeg.', loading: 'Laden…', cartLoadError: 'Winkelwagen kon niet worden geladen.', qty: 'Aantal', invalidVariant: 'Ongeldige variant', addError: 'Kon niet aan winkelwagen toevoegen', adding: 'Toevoegen…', added: 'Toegevoegd ✓', retry: 'Probeer opnieuw', add: 'In winkelwagen', sold: 'Uitverkocht', stock: 'Op voorraad', cartError: 'Winkelwagenfout'
    },
    de: {
      empty: 'Dein Warenkorb ist leer.', loading: 'Laden…', cartLoadError: 'Warenkorb konnte nicht geladen werden.', qty: 'Menge', invalidVariant: 'Ungültige Variante', addError: 'Konnte nicht zum Warenkorb hinzugefügt werden', adding: 'Hinzufügen…', added: 'Hinzugefügt ✓', retry: 'Erneut versuchen', add: 'In den Warenkorb', sold: 'Ausverkauft', stock: 'Auf Lager', cartError: 'Warenkorbfehler'
    },
    fr: {
      empty: 'Votre panier est vide.', loading: 'Chargement…', cartLoadError: 'Impossible de charger le panier.', qty: 'Qté', invalidVariant: 'Variante invalide', addError: 'Impossible d’ajouter au panier', adding: 'Ajout…', added: 'Ajouté ✓', retry: 'Réessayer', add: 'Ajouter au panier', sold: 'Épuisé', stock: 'En stock', cartError: 'Erreur du panier'
    },
    fa: {
      empty: 'سبد خرید شما خالی است.', loading: 'در حال بارگذاری…', cartLoadError: 'سبد خرید بارگذاری نشد.', qty: 'تعداد', invalidVariant: 'گزینه محصول نامعتبر است', addError: 'افزودن به سبد خرید انجام نشد', adding: 'در حال افزودن…', added: 'اضافه شد ✓', retry: 'دوباره تلاش کنید', add: 'افزودن به سبد خرید', sold: 'ناموجود', stock: 'موجود', cartError: 'خطای سبد خرید'
    },
    ar: {
      empty: 'سلة التسوق فارغة.', loading: 'جارٍ التحميل…', cartLoadError: 'تعذر تحميل سلة التسوق.', qty: 'الكمية', invalidVariant: 'خيار المنتج غير صالح', addError: 'تعذر الإضافة إلى سلة التسوق', adding: 'جارٍ الإضافة…', added: 'تمت الإضافة ✓', retry: 'حاول مرة أخرى', add: 'أضف إلى السلة', sold: 'نفد المخزون', stock: 'متوفر', cartError: 'خطأ في سلة التسوق'
    },
    en: {
      empty: 'Your cart is empty.', loading: 'Loading…', cartLoadError: 'Could not load cart.', qty: 'Qty', invalidVariant: 'Invalid variant', addError: 'Could not add to cart', adding: 'Adding…', added: 'Added ✓', retry: 'Try again', add: 'Add to cart', sold: 'Sold out', stock: 'In stock', cartError: 'Cart error'
    }
  };
  const copy = dictionaries[lang] || dictionaries.en;
  const shopRoot = window.Shopify?.routes?.root || '/';

  /* MBF entrance: looping heartbeat + soft cinematic opening sound. */
  const entryGate = qs('[data-mbf-entry]');
  if (entryGate) {
    let seen = false;
    try { seen = sessionStorage.getItem('mbf_entry_seen_v2') === '1'; } catch (_) {}

    let heartCtx = null;
    let heartTimer = null;
    let heartbeatRunning = false;
    let heartMaster = null;
    const activeHeartNodes = new Set();

    const ensureHeartContext = async () => {
      try {
        if (!heartCtx) {
          const AudioCtx = window.AudioContext || window.webkitAudioContext;
          if (!AudioCtx) return null;
          heartCtx = new AudioCtx();
        }
        if (heartCtx.state === 'suspended') {
          try { await heartCtx.resume(); } catch (_) {}
        }
        return heartCtx;
      } catch (_) {
        return null;
      }
    };

    const ensureHeartMaster = (ctx) => {
      if (heartMaster) return heartMaster;
      heartMaster = ctx.createGain();
      heartMaster.gain.setValueAtTime(0.72, ctx.currentTime);
      heartMaster.connect(ctx.destination);
      return heartMaster;
    };

    const trackNode = (node) => {
      activeHeartNodes.add(node);
      node.addEventListener?.('ended', () => activeHeartNodes.delete(node), { once:true });
      return node;
    };

    const synthThump = (ctx, when, strength = 1) => {
      const master = ensureHeartMaster(ctx);

      const osc = trackNode(ctx.createOscillator());
      const gain = ctx.createGain();
      const filter = ctx.createBiquadFilter();
      filter.type = 'lowpass';
      filter.frequency.value = 175;
      osc.type = 'sine';
      osc.frequency.setValueAtTime(98, when);
      osc.frequency.exponentialRampToValueAtTime(46, when + 0.14);
      gain.gain.setValueAtTime(0.0001, when);
      gain.gain.exponentialRampToValueAtTime(0.40 * strength, when + 0.012);
      gain.gain.exponentialRampToValueAtTime(0.0001, when + 0.19);
      osc.connect(filter);
      filter.connect(gain);
      gain.connect(master);
      osc.start(when);
      osc.stop(when + 0.21);

      const body = trackNode(ctx.createOscillator());
      const bodyGain = ctx.createGain();
      body.type = 'triangle';
      body.frequency.setValueAtTime(62, when);
      body.frequency.exponentialRampToValueAtTime(35, when + 0.17);
      bodyGain.gain.setValueAtTime(0.0001, when);
      bodyGain.gain.exponentialRampToValueAtTime(0.18 * strength, when + 0.014);
      bodyGain.gain.exponentialRampToValueAtTime(0.0001, when + 0.20);
      body.connect(bodyGain);
      bodyGain.connect(master);
      body.start(when);
      body.stop(when + 0.22);
    };

    const heartbeatCycle = () => {
      if (!heartbeatRunning || !heartCtx || heartCtx.state !== 'running' || entryGate.hidden) return;
      const now = heartCtx.currentTime + 0.02;
      synthThump(heartCtx, now, 0.84);
      synthThump(heartCtx, now + 0.265, 1.0);
    };

    const startHeartbeat = async () => {
      const ctx = await ensureHeartContext();
      if (!ctx || ctx.state !== 'running') {
        heartbeatRunning = false;
        return false;
      }
      ensureHeartMaster(ctx);
      if (heartbeatRunning && heartTimer) return true;

      heartbeatRunning = true;
      try {
        heartMaster.gain.cancelScheduledValues(ctx.currentTime);
        heartMaster.gain.setValueAtTime(0.72, ctx.currentTime);
      } catch (_) {}

      heartbeatCycle();
      heartTimer = window.setInterval(heartbeatCycle, 1750);
      return true;
    };

    const stopHeartbeatHard = () => {
      heartbeatRunning = false;
      if (heartTimer) {
        window.clearInterval(heartTimer);
        heartTimer = null;
      }
      if (heartCtx && heartMaster) {
        try {
          const now = heartCtx.currentTime;
          heartMaster.gain.cancelScheduledValues(now);
          heartMaster.gain.setValueAtTime(Math.max(0.0001, heartMaster.gain.value || 0.72), now);
          heartMaster.gain.exponentialRampToValueAtTime(0.0001, now + 0.035);
        } catch (_) {}
      }
      activeHeartNodes.forEach((node) => {
        try { node.stop(); } catch (_) {}
      });
      activeHeartNodes.clear();
    };


    const playEntryOpenSound = async () => {
      const ctx = await ensureHeartContext();
      if (!ctx || ctx.state !== 'running') return;

      const now = ctx.currentTime + 0.025;

      // Cinematic low-end impact: deep but short, no harsh highs.
      const sub = ctx.createOscillator();
      const subGain = ctx.createGain();
      sub.type = 'sine';
      sub.frequency.setValueAtTime(76, now);
      sub.frequency.exponentialRampToValueAtTime(36, now + 0.52);
      subGain.gain.setValueAtTime(0.0001, now);
      subGain.gain.exponentialRampToValueAtTime(0.17, now + 0.025);
      subGain.gain.exponentialRampToValueAtTime(0.0001, now + 0.56);
      sub.connect(subGain);
      subGain.connect(ctx.destination);
      sub.start(now);
      sub.stop(now + 0.58);

      // Short punch above the sub so the hit is audible on phone speakers.
      const punch = ctx.createOscillator();
      const punchGain = ctx.createGain();
      const punchFilter = ctx.createBiquadFilter();
      punch.type = 'triangle';
      punch.frequency.setValueAtTime(135, now);
      punch.frequency.exponentialRampToValueAtTime(58, now + 0.24);
      punchFilter.type = 'lowpass';
      punchFilter.frequency.value = 240;
      punchGain.gain.setValueAtTime(0.0001, now);
      punchGain.gain.exponentialRampToValueAtTime(0.075, now + 0.012);
      punchGain.gain.exponentialRampToValueAtTime(0.0001, now + 0.30);
      punch.connect(punchFilter);
      punchFilter.connect(punchGain);
      punchGain.connect(ctx.destination);
      punch.start(now);
      punch.stop(now + 0.32);
    };

    const triggerEntryHaptic = () => {
      try {
        if ('vibrate' in navigator) {
          navigator.vibrate([30, 24, 55]);
          return true;
        }
      } catch (_) {}
      return false;
    };

    const finishEntry = (animated = true) => {
      if (!entryGate || entryGate.hidden) return;
      try { sessionStorage.setItem('mbf_entry_seen_v2', '1'); } catch (_) {}

      if (animated && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        entryGate.classList.add('is-opening');
        window.setTimeout(() => {
          entryGate.classList.remove('is-active', 'is-opening');
          entryGate.hidden = true;
          entryGate.setAttribute('aria-hidden', 'true');
          setBodyLock();
          try { heartCtx?.close(); } catch (_) {}
        }, 1080);
      } else {
        entryGate.classList.remove('is-active', 'is-opening');
        entryGate.hidden = true;
        entryGate.setAttribute('aria-hidden', 'true');
        setBodyLock();
        try { heartCtx?.close(); } catch (_) {}
      }
    };

    if (!seen) {
      entryGate.hidden = false;
      entryGate.setAttribute('aria-hidden', 'false');

      requestAnimationFrame(() => {
        entryGate.classList.add('is-active');
        setBodyLock();
        qs('[data-mbf-entry-open]', entryGate)?.focus({ preventScroll: true });
      });

      const openButton = qs('[data-mbf-entry-open]', entryGate);

      // Try immediately. Desktop browsers that allow it will start here.
      startHeartbeat();

      // iOS/Safari blocks audible autoplay before user interaction.
      // Unlock on the first interaction anywhere.
      const unlockHeartbeat = async () => {
        await startHeartbeat();
      };

      if ('PointerEvent' in window) {
        document.addEventListener('pointerdown', unlockHeartbeat, { once:true, capture:true });
      } else {
        document.addEventListener('touchstart', unlockHeartbeat, { once:true, capture:true, passive:true });
      }

      // If the first interaction IS the logo, start heartbeat immediately on press.
      // Then let one full heartbeat cycle be heard before the flatline tone.
      let logoPressStartedAt = 0;
      const startOnLogoPress = async () => {
        logoPressStartedAt = performance.now();
        await startHeartbeat();
      };

      if (openButton) {
        if ('PointerEvent' in window) {
          openButton.addEventListener('pointerdown', startOnLogoPress, { once:true });
        } else {
          openButton.addEventListener('touchstart', startOnLogoPress, { once:true, passive:true });
        }
      }

      let entering = false;
      openButton?.addEventListener('click', async () => {
        if (entering) return;
        entering = true;

        await startHeartbeat();

        const elapsed = logoPressStartedAt ? (performance.now() - logoPressStartedAt) : 0;
        const waitForBeat = Math.max(520, 760 - elapsed);

        window.setTimeout(async () => {
          stopHeartbeatHard();
          entryGate.classList.add('is-haptic-impact');
          triggerEntryHaptic();
          await playEntryOpenSound();
          finishEntry(true);
        }, waitForBeat);
      });

      qs('[data-mbf-entry-skip]', entryGate)?.addEventListener('click', () => {
        stopHeartbeatHard();
        finishEntry(false);
      });
    }
  }

  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'EUR';
    const locale = document.documentElement.lang || 'en';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return `€${((Number(cents) || 0) / 100).toFixed(2)}`;
    }
  };

  const setBodyLock = () => {
    const anyOpen = !qs('[data-mbf-cart-drawer]')?.hidden || !qs('[data-mbf-ai-modal]')?.hidden || !qs('[data-mbf-mobile-menu]')?.hidden || !qs('[data-mbf-entry]')?.hidden;
    body.classList.toggle('is-locked', anyOpen);
  };

  /* Mobile navigation */
  const mobileMenu = qs('[data-mbf-mobile-menu]');
  qsa('[data-mbf-menu-open]').forEach((el) => el.addEventListener('click', () => {
    if (!mobileMenu) return;
    mobileMenu.hidden = false;
    setBodyLock();
  }));
  qsa('[data-mbf-menu-close]').forEach((el) => el.addEventListener('click', () => {
    if (!mobileMenu) return;
    mobileMenu.hidden = true;
    setBodyLock();
  }));

  /* Cart drawer */
  const cartDrawer = qs('[data-mbf-cart-drawer]');
  const cartBody = qs('[data-mbf-cart-body]');
  const cartFooter = qs('[data-mbf-cart-footer]');

  const updateCartBadge = (count) => {
    qsa('[data-mbf-cart-count]').forEach((badge) => {
      badge.textContent = count;
      badge.hidden = !count;
    });
  };

  const renderCart = (cart) => {
    if (!cartBody || !cartFooter) return;
    updateCartBadge(cart.item_count || 0);

    if (!cart.item_count) {
      cartBody.innerHTML = `<div class="drawer__empty"><strong>${copy.empty}</strong></div>`;
      cartFooter.hidden = true;
      return;
    }

    cartBody.innerHTML = cart.items.map((item) => {
      const image = item.image ? `<img src="${item.image}" alt="">` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<span>${item.variant_title}</span>` : '';
      return `
        <article class="drawer-item">
          <a href="${item.url}">${image}</a>
          <div class="drawer-item__copy">
            <a href="${item.url}">${item.product_title}</a>
            ${variant}
            <span>${copy.qty} ${item.quantity}</span>
          </div>
          <div class="drawer-item__price">${money(item.final_line_price)}</div>
        </article>`;
    }).join('');

    const subtotal = qs('[data-mbf-cart-subtotal]');
    if (subtotal) subtotal.textContent = money(cart.total_price);
    cartFooter.hidden = false;
  };

  const fetchCart = async () => {
    const response = await fetch(`${shopRoot}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(copy.cartLoadError);
    return response.json();
  };

  const openCart = async () => {
    if (!cartDrawer) return;
    cartDrawer.hidden = false;
    if (cartBody) cartBody.innerHTML = `<div class="drawer__loading">${copy.loading}</div>`;
    setBodyLock();
    try { renderCart(await fetchCart()); } catch (_) {
      if (cartBody) cartBody.innerHTML = `<div class="drawer__empty">${copy.cartLoadError}</div>`;
    }
  };

  const closeCart = () => {
    if (!cartDrawer) return;
    cartDrawer.hidden = true;
    setBodyLock();
  };

  qsa('[data-mbf-cart-open]').forEach((el) => el.addEventListener('click', openCart));
  qsa('[data-mbf-cart-close]').forEach((el) => el.addEventListener('click', closeCart));

  const addToCart = async (variantId, quantity = 1) => {
    const numericId = String(variantId || '').replace(/\D/g, '');
    if (!numericId) throw new Error(copy.invalidVariant);
    const response = await fetch(`${shopRoot}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(numericId), quantity: Math.max(1, Number(quantity) || 1) }] })
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(result?.description || result?.message || copy.addError);
    const cart = await fetchCart();
    renderCart(cart);
    return cart;
  };

  qsa('[data-mbf-quick-add]').forEach((button) => {
    button.addEventListener('click', async () => {
      const original = button.textContent;
      button.disabled = true;
      button.textContent = copy.adding;
      try {
        await addToCart(button.dataset.variantId, 1);
        button.textContent = copy.added;
        await openCart();
      } catch (error) {
        button.textContent = error.message || copy.retry;
      } finally {
        window.setTimeout(() => { button.disabled = false; button.textContent = original; }, 1400);
      }
    });
  });

  /* Product page */
  const productRoot = qs('[data-mbf-product-root]');
  if (productRoot) {
    const variantInput = qs('[data-mbf-product-variant-input]', productRoot);
    const priceEl = qs('[data-mbf-product-price]', productRoot);
    const stockEl = qs('[data-mbf-product-stock]', productRoot);
    const selectedLabel = qs('[data-mbf-selected-variant]', productRoot);
    const addButton = qs('[data-mbf-product-add]', productRoot);
    const addLabel = qs('[data-mbf-product-add-label]', productRoot);
    const stickyPrice = qs('[data-mbf-sticky-price]');

    qsa('[data-mbf-variant]', productRoot).forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        qsa('[data-mbf-variant]', productRoot).forEach((item) => item.classList.remove('is-selected'));
        button.classList.add('is-selected');
        if (variantInput) variantInput.value = button.dataset.variantId;
        if (priceEl) priceEl.textContent = button.dataset.variantPrice || '';
        if (stickyPrice) stickyPrice.textContent = button.dataset.variantPrice || '';
        if (selectedLabel) selectedLabel.textContent = button.dataset.variantTitle || '';
        const available = button.dataset.variantAvailable === 'true';
        if (addButton) addButton.disabled = !available;
        if (addLabel) addLabel.textContent = available ? copy.add : copy.sold;
        if (stockEl) {
          stockEl.textContent = available ? copy.stock : copy.sold;
          stockEl.classList.toggle('status-pill--in', available);
          stockEl.classList.toggle('status-pill--out', !available);
        }
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', String(button.dataset.variantId).replace(/\D/g, ''));
          history.replaceState({}, '', url);
        } catch (_) {}
      });
    });

    const qtyInput = qs('[data-mbf-qty-input]', productRoot);
    qs('[data-mbf-qty-minus]', productRoot)?.addEventListener('click', () => {
      if (!qtyInput) return;
      qtyInput.value = Math.max(1, (Number(qtyInput.value) || 1) - 1);
    });
    qs('[data-mbf-qty-plus]', productRoot)?.addEventListener('click', () => {
      if (!qtyInput) return;
      qtyInput.value = Math.max(1, (Number(qtyInput.value) || 1) + 1);
    });

    const addForm = qs('#MBFProductForm', productRoot);
    addForm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!variantInput || !addButton) return;
      const original = addLabel?.textContent || copy.add;
      addButton.disabled = true;
      if (addLabel) addLabel.textContent = copy.adding;
      try {
        await addToCart(variantInput.value, qtyInput?.value || 1);
        if (addLabel) addLabel.textContent = copy.added;
        await openCart();
      } catch (error) {
        if (addLabel) addLabel.textContent = error.message || copy.retry;
      } finally {
        window.setTimeout(() => {
          addButton.disabled = false;
          if (addLabel) addLabel.textContent = original;
        }, 1400);
      }
    });

    qsa('[data-mbf-gallery-thumb]', productRoot).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const main = qs('[data-mbf-gallery-main]', productRoot);
        if (!main || !thumb.dataset.src) return;
        main.src = thumb.dataset.src;
        main.removeAttribute('srcset');
        qsa('[data-mbf-gallery-thumb]', productRoot).forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    const sticky = qs('[data-mbf-sticky-atc]');
    if (sticky && addButton && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      const observer = new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && window.scrollY > 380);
      }, { threshold: 0.1 });
      observer.observe(addButton);
    }
    qs('[data-mbf-sticky-add]')?.addEventListener('click', () => addButton?.click());
  }

  /* Collection filters */
  qs('[data-mbf-filter-toggle]')?.addEventListener('click', () => qs('.filters')?.classList.toggle('is-open'));

  /* AI assistant */
  const aiModal = qs('[data-mbf-ai-modal]');
  const aiFrame = qs('[data-mbf-ai-frame]');
  let aiOrigin = '';
  try { aiOrigin = new URL(aiFrame?.dataset.src || '', window.location.href).origin; } catch (_) {}

  const openAI = (event) => {
    if (!aiModal || !aiFrame) return;
    if (!aiFrame.getAttribute('src')) {
      const rawContext = event?.currentTarget?.dataset?.mbfAiContext || document.title || 'The Muscle Body Factory';
      try {
        const frameUrl = new URL(aiFrame.dataset.src || '', window.location.href);
        frameUrl.searchParams.set('context', String(rawContext).slice(0, 500));
        aiFrame.src = frameUrl.toString();
      } catch (_) {
        aiFrame.src = aiFrame.dataset.src || '';
      }
    }
    aiModal.hidden = false;
    setBodyLock();
  };
  const closeAI = () => {
    if (!aiModal) return;
    aiModal.hidden = true;
    setBodyLock();
  };
  qsa('[data-mbf-ai-open]').forEach((el) => el.addEventListener('click', openAI));
  qsa('[data-mbf-ai-close]').forEach((el) => el.addEventListener('click', closeAI));

  /* Secure parent-page bridge for the existing MBF AI iframe. */
  window.addEventListener('message', async (event) => {
    if (!aiFrame || event.source !== aiFrame.contentWindow || !aiOrigin || event.origin !== aiOrigin) return;
    const data = event.data;
    if (!data || data.source !== 'thembf-ai' || data.type !== 'MBF_ADD_TO_CART') return;
    const requestId = String(data.requestId || '');
    try {
      await addToCart(data.variantId, data.quantity || 1);
      event.source?.postMessage({ source: 'thembf-store', type: 'MBF_CART_RESULT', requestId, ok: true }, aiOrigin);
      closeAI();
      await openCart();
    } catch (error) {
      event.source?.postMessage({ source: 'thembf-store', type: 'MBF_CART_RESULT', requestId, ok: false, error: error instanceof Error ? error.message : copy.cartError }, aiOrigin);
    }
  });

  /* Escape closes overlays */
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (entryGate && !entryGate.hidden) {
      try { sessionStorage.setItem('mbf_entry_seen_v2', '1'); } catch (_) {}
      entryGate.classList.remove('is-active', 'is-opening');
      entryGate.hidden = true;
      entryGate.setAttribute('aria-hidden', 'true');
    }
    closeCart();
    closeAI();
    if (mobileMenu) mobileMenu.hidden = true;
    setBodyLock();
  });
})();
